export default __webpack_public_path__ + "static/media/gwc-ht.a66d387c.png";